var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#0F5BF1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 15.8124L14.6667 11.4583V20.1666L20.1667 15.8124Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83334 14.2083H16.0939V17.4166H1.83334V14.2083ZM1.83334 6.18742L7.33334 1.83325V10.5416L1.83334 6.18742Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9061 4.58325H20.1667V7.79159H5.9061V4.58325Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/TransferIcon.88fbd4fa932f362878bbf512caab2b6b.svg";
export { ForwardRef as ReactComponent };